export enum ViewMode {
  DEFAULT = 'default',
  FORCE = 'force',
}